import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';
import { navigateInternally } from 'utils/bolt';
import parseQueryString from 'utils/parseQueryString';
import { getDynamicData } from 'utils/bolt/dynamicData';

// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	constructor(props) {
		super(props);
		this.checkForRedirects();
		let qs = parseQueryString();
		if (qs.previewDataPath) {
			this.loadDynamicData(qs.previewDataPath);
		}
	}

	componentWillUpdate(nextProps, nextState) {
		super.componentWillUpdate?.(nextProps, nextState);
		this.checkForRedirects(nextState);
	}

	async loadDynamicData(path) {
		const dynamicData = await getDynamicData('film-pages');
		const data = path?.split('.').reduce((d, p) => d?.[p], dynamicData);
		if (!data) {
			return;
		}
		try {
			const homeEntFirst = data.watch?.homeEntFirst;
			const oneSheets = {
				desktop: { asset: data.watch?.onesheet },
				tabletLandscape: { asset: data.watch?.mobileOnesheet },
				tablet: { asset: data.watch?.mobileOnesheet },
				mobile: { asset: data.watch?.mobileOnesheet }
			};

			Store.get().appData.pages.boltShowtimes.set({ order: homeEntFirst ? 2 : 1 });
			const boundingRegions = data.watch.boundingRegions?.split(',').map(r => r.trim()).filter(r => r) || [];
			Store.get().appData.pages.boltShowtimes.data.set({
				movieId: data.watch?.movieId,
				boundingRegions: Object.fromEntries(boundingRegions.map(r => [r, true])),
				bg: oneSheets
			});
			Store.get().appData.pages.boltHomeEnt.set({ order: homeEntFirst ? 1 : 2 });
			Store.get().appData.pages.boltHomeEnt.data.set({
				addProducts: {
					digital: data.watch?.homeEntData?.reduce?.((data, e) => {
						if (!e?.name) {
							return data;
						}
						data[e.name] = { merchantName: e.name, stream: { [e.name]: { link: e.link } } };
						return data;
					}, {}) || {}
				},
				overrideMerchantDetails: data.watch?.homeEntData?.reduce?.((data, e) => {
					if (!e?.name) {
						return data;
					}
					data[e.name] = { name: e.name, logo: e.logo };
					return data;
				}, {}),
				bg: oneSheets
			});
			const showShowtimes = !!data.watch?.showShowtimes;
			const showHomeEnt = !!data.watch?.showHomeEnt;
			const defaultPage = showHomeEnt && (homeEntFirst || !showShowtimes) ? 'boltHomeEnt' : showShowtimes ? 'boltShowtimes' : 'boltTextPage';
			if (!showShowtimes) {
				Store.get().appData.pages.remove('boltShowtimes');
			}
			if (!showHomeEnt) {
				Store.get().appData.pages.remove('boltHomeEnt');
			}
			// Happens probably too late, but only used for preview anyway
			// if (/^G-[A-Z0-9]+$/.test(data.ga)) {
			// 	Store.get().appData.tracking.variables.set({ powTitle: data.ga });
			// }

			navigateInternally(defaultPage);
		} catch (e) {}
	}

	checkForRedirects(state = this.state) {
		if (__IS_LOCAL__ || typeof window === 'undefined' || /[?&]redirect=(off|false|0|no)/.test(location.search)) {
			return;
		}

		const { activePage, appData } = state.appState;
		const redirect = appData.pages[activePage]?.redirectTo;
		if (redirect) {
			location.href = redirect;
		}
	}

}
